<div class="stepper" [class.vertical]="orientation === 'vertical'" [class.indicator-only]="indicatorOnly">
  <div class="stepper-header">
    <ng-container *ngFor="let step of steps; let i = index">
      <div [class.disabled]="!step.isDisabled" *ngIf="orientation !== 'vertical' && i > 0" class="step-divider"></div>

      <div
        class="step"
        [class.vertical]="orientation === 'vertical'"
        [class.active]="step.isSelected"
        [class.completed]="step.isCompleted"
        [class.disabled]="!step.isDisabled"
        [class.editable]="step.isDisabled"
        [class.error]="step.error"
      >
        <div *ngIf="orientation === 'vertical' && i > 0" class="vertical-line-container">
          <div class="vertical-connection-line" [class.disabled]="!step.isDisabled"></div>
        </div>
        <div class="step-content">
          <div class="circle" [class.completed]="step.isCompleted" (click)="step.isDisabled ? selectStep(i) : null">
            <ds-icon
              *ngIf="step.isCompleted && !step.isSelected && !step.error && step.isDisabled"
              icon="check"
              class="checkmark"
            ></ds-icon>
            <span
              *ngIf="(!step.isCompleted || step.isSelected || !step.isDisabled) && !step.error"
              class="step-number"
              >{{ step.stepNumber }}</span
            >
            <ds-icon *ngIf="step.error" icon="exclamation-line" class="error-icon"></ds-icon>
          </div>
          <div class="step-info" [class.horizontal]="orientation === 'horizontal'">
            <div class="label">{{ step.displayLabel }}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="stepper-content" *ngIf="!indicatorOnly" [class.vertical]="orientation === 'vertical'">
    <div [@contentAnimation]="selectedIndex">
      <ng-content select="ds-step"></ng-content>
    </div>
    <ng-content select="ds-footer-stepper"></ng-content>
  </div>
</div>
